import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import StepsComponent from '../components/Steps'
import { getImagesFromApi, setSelectionResult } from '../actions';

class Steps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stepsNumber: 1,
            error: false,
            errorInfo: null,
            styleSelection: {}
        };
    }

    componentWillMount = () => {
        if (!this.props.images) {
            this.props.getImagesFromApi()
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if(!nextProps.images) {
            this.props.getImagesFromApi()
        }
    }

    componentDidCatch = (error, info) => {
        this.setState({ error: true, errorInfo: info })
    }

    handleNext = (style) => {
        let selection = {...this.state.styleSelection }
        if (`${style}` in selection) {
            selection[`${style}`]++
        } else {
            selection[`${style}`] = 1
        }

        if (this.state.stepsNumber === 10) {
            this.props.setSelectionResult(selection)
            this.props.history.push(`/result`);
        }

        this.setState({
            stepsNumber: this.state.stepsNumber + 1,
            styleSelection: selection
        })
    };

    render() {
        let imgs = null;
        if (this.props.images) {
            imgs = this.props.images.filter((item) => item.ORDER === this.state.stepsNumber)
        }
        return (
            <StepsComponent stepsNumber={this.state.stepsNumber} images={imgs} handleNext={this.handleNext} />
        );
    }
}

const mapStateProps = (state) => {
    return {
        images: state.ImagesReducer.images
    }
}

export default withRouter(connect(mapStateProps, { getImagesFromApi, setSelectionResult })(Steps));
